import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import SuperDistributorDashboard from '../pages/modules/super_distributor';
import UserManagementRetailer from '../pages/modules/super_distributor/UserManagementRetailer';
import UserManagementDistributor from '../pages/modules/super_distributor/UserManagementDistributor';
import UserManagementMasterDistributor from '../pages/modules/super_distributor/UserManagementMasterDistributor';
import TopUpRequestFromRetailer from '../pages/modules/super_distributor/TopUpRequestFromRetailer';
import SendTopUpRequest from '../pages/modules/super_distributor/SendTopUpRequest';
import ReportsLedger from '../pages/modules/super_distributor/ReportsLedger';
import ReportsCommission from '../pages/modules/super_distributor/ReportsCommission';
import ReportsTopUpHistory from '../pages/modules/super_distributor/ReportsTopUpHistory';
import ReportsOutstanding from '../pages/modules/super_distributor/ReportsOutstanding';
import ReportsSetBalanceLimit from '../pages/modules/super_distributor/ReportsSetBalanceLimit';
import ReportsOutstandingSummary from '../pages/modules/super_distributor/ReportsOutstandingSummary';
import ReportsDistributorTransactions from '../pages/modules/super_distributor/ReportsDistributorTransactions';
import ReportsRetailerTransactions from '../pages/modules/super_distributor/ReportsRetailerTransactions';
import ReportsMasterDistributorTransactions from '../pages/modules/super_distributor/ReportsMasterDistributorTransactions';
import MyProfile from '../pages/profile/MyProfile';

const SuperDistributorRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<SuperDistributorDashboard />} />
      <Route path="/user-management/master-distributor" element={<UserManagementMasterDistributor />} />
      <Route path="/user-management/distributor" element={<UserManagementDistributor />} />
      <Route path="/user-management/retailer" element={<UserManagementRetailer />} />
      <Route path="/top-up-request/from-retailer" element={<TopUpRequestFromRetailer />} />
      <Route path="/top-up-request/send" element={<SendTopUpRequest />} />
      <Route path="/reports/ledger" element={<ReportsLedger />} />
      <Route path="/reports/commission" element={<ReportsCommission />} />
      <Route path="/reports/top-up-history" element={<ReportsTopUpHistory />} />
      <Route path="/reports/master-distributor-transactions" element={<ReportsMasterDistributorTransactions />} />
      <Route path="/reports/distributor-transactions" element={<ReportsDistributorTransactions />} />
      <Route path="/reports/retailer-transactions" element={<ReportsRetailerTransactions />} />
      <Route path="/reports/outstanding-reports" element={<ReportsOutstanding />} />
      <Route path="/reports/set-balance-limit" element={<ReportsSetBalanceLimit />} />
      <Route path="/reports/outstanding" element={<ReportsOutstandingSummary />} />
      <Route path="/profile" element={<MyProfile />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default SuperDistributorRoutes;

